export module CONFIGURATION {

    export const modeEnv = "UAT";
    export const SESSIONTIMEOUT: number = 450;   //in seconds - 7.5 mins
    //export const SESSIONTIMEOUT:number = 12;   //in seconds - 7.5 mins

    export const ENCRYPTION = {
        // set key
        KEY: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
        KEY_LENGTH: 64,
        REQUEST: true
    };

    export const SERVICE = {
        TIME_OUT: 60000
    }

    export const FILE = {
        MAX_SIZE: 10485760
    }

    export const payRedirectConfig = {
        LOCAL: {
            URL: "http://localhost:4200"
        },
        DEV: { // This will be consider as a SIT
            URL: "http://10.3.22.20:4200"
        },
        UAT: {
            URL: "http://10.3.22.20:5000"
        },
        PROD: {
            URL: "https://Netlinkpay.com"  //"Kowsalya: Text changed for NLT PRP portal development"
        }
    }

    //GANESH
    export const invoicePath = {
        LOCAL: {
            PATH: "./assets/Invoice/"
        },
        DEV: {
            PATH: "http://nce-web-portal.s3-website-ap-southeast-1.amazonaws.com"
        },
        UAT: {
            PATH: "http://nce-portal-uat.s3-website-ap-southeast-1.amazonaws.com"
        },
        PROD: {
            PATH: "https://Netlinkpay.com" //"Kowsalya: Text changed for NLT PRP portal development"
        }
    }

    //GANESH
    export const plantmapPath = {
        LOCAL: {
            PATH: "./assets/PlantMap/"
        },
        DEV: {
            PATH: "http://nce-web-portal.s3-website-ap-southeast-1.amazonaws.com"
        },
        UAT: {
            PATH: "http://nce-portal-uat.s3-website-ap-southeast-1.amazonaws.com"
        },
        PROD: {
            PATH: "https://Netlinkpay.com" //"Kowsalya: Text changed for NLT PRP portal development"
        }
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/configuration/configuration.ts